export default __webpack_public_path__ + "static/media/672.dcd1fe1f.png";